<script setup lang="ts">
import { ref } from "vue";
import { useDeviceState } from "@/stores/DeviceState";
import DRDropdownItem from "@/components/UI/DRDropdownItem.vue";
import ConfirmationModal from "@/components/generic/ConfirmationModal.vue";
import { useArchiveDrawing } from "@/stores/queries";

const props = defineProps<{
  drawingId?: number;
}>();
const { mutateAsync, isPending } = useArchiveDrawing();

const deviceState = useDeviceState();
const showConfirm = ref(false);

function archiveDrawing() {
  if (!props.drawingId) return;
  mutateAsync(props.drawingId, {
    onSuccess: () => {
      showConfirm.value = false;
    },
  });
}
</script>
<template>
  <DRDropdownItem
    :disabled="!drawingId || !deviceState.isOnline"
    @select="showConfirm = true"
    icon="bi-archive"
    :label="$t('dashboard:archive-plan')"
  />

  <ConfirmationModal
    v-model="showConfirm"
    :title="$t('dashboard:drawings.archive.confirmation.single.title')"
    :message="$t('dashboard:drawings.archive.confirmation.single.message')"
    :loading="isPending"
    @confirm="archiveDrawing"
  />
</template>
